"use strict";
exports.__esModule = true;
exports.Points = void 0;
var distance_1 = require("./distance");
var equals_1 = require("./equals");
var isValid_1 = require("./isValid");
var parse_1 = require("./parse");
var toLatLong_1 = require("./toLatLong");
var toString_1 = require("./toString");
var transform_1 = require("./transform");
exports.Points = {
    distance: distance_1.distance,
    equals: equals_1.equals,
    isValid: isValid_1.isValid,
    parse: parse_1.parse,
    toLatLong: toLatLong_1.toLatLong,
    toString: toString_1.toString,
    transform: transform_1.transform
};
//# sourceMappingURL=index.js.map